import useAuth from "libs/hooks/useAuth";
import httpClientInstants from "libs/utils/HttpClient";
import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { logout } from "redux/modules/authSlice";
import { persistor } from "redux/store";

export default function LogoutPage() {
  const dispatch = useDispatch();
  const history = useHistory();
  const { accessToken } = useAuth();

  useEffect(() => {
    (async () => {
      await persistor.flush();
      dispatch(logout());
      httpClientInstants.setToken("");
    })();
  }, [dispatch]);

  useEffect(() => {
    if (!accessToken) {
      history.replace("/");
    }
  }, [accessToken, history]);

  return <div>Logout...</div>;
}
